namespace AgerLMS.Logging {
    export class LessonWatchLogBackupColumns {
        static columnsKey = 'Logging.LessonWatchLogBackup';
    }
}
